import * as React from 'react';
import { NavLink } from 'react-router-dom';

import './index.scss';

export interface AreaNavItem {
	to: string;
	exact?: boolean;
	text: string;
	locked?: boolean;
}

export interface AreaNavProps {
	items: AreaNavItem[];
}

export default class AreaNav extends React.Component<AreaNavProps> {
	public render() {
		return (
			<ul className="area-navigation">
				{this.props.items.map((item) => {
					const { text, locked, ...rest } = item;
					return (
						<li key={item.to}>
							{locked ? (
								<span className="locked">
									<span className="area-nav-lock" />
									{text}
								</span>
							) : (
								<NavLink {...rest} activeClassName="active">
									{text}
								</NavLink>
							)}
						</li>
					);
				})}
			</ul>
		);
	}
}
